<template>
  <div v-if="show" class="modal-overlay">
    <div class="modal-content">
      <header class="modal-header">
        <div class="header-text">
          <h2 class="modal-title">Avaliar este app</h2>
        </div>
        <button class="close-button" @click="$emit('close')">&times;</button>
      </header>
      <main>
        <p>De 0 a 10, o quanto você recomendaria esse sistema a um colega de profissão?</p>
        <div class="nps-icons">
          <div
            v-for="n in 11"
            :key="n"
            class="nps-item"
            @click="rate(n - 1)"
          >
            <img
              :src="require(`@/assets/icones/Nps/${n - 1}.png`)"
              :class="{'selected': rating === n - 1}"
              alt=""
            />
            <div class="nps-number" :class="{'selected': rating === n - 1}">
              {{ n - 1 }}
            </div>
          </div>
        </div>
        <div class="textarea-container">
          <div class="textarea-wrapper">
            <textarea v-model="feedback" placeholder="Descreva sua experiência ou faça uma sugestão (Opcional)"></textarea>
            <div class="microphone-container">
              <SpeechRecognition :targetModel.sync="feedback" />
            </div>
          </div>
        </div>
      </main>
      <footer id="footer-submit">
        <button @click="submitFeedback" :disabled="rating === null || loadingBtn" class="submit-button">
          <span v-if="!loadingBtn">Enviar</span>
          <b-spinner label="Spinning" small variant="white" v-if="loadingBtn"></b-spinner>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import SpeechRecognition from '@/pages/AvaliacaoTreinamento/components/SpeechRecognition.vue';
import { apiPublic } from '@/plugins/axios.js'
import { api } from '@/plugins/axios.js'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SpeechRecognition,
  },
  data() {
    return {
      feedback: '',
      rating: null,
      escala: '',
      enviadoComSucesso: false,
      loadingBtn: false,
    };
  },
  methods: {
    rate(n) {
      this.rating = n;
      this.setEscala(n);
    },
    setEscala(n) {
      if (n >= 9) {
        this.escala = 'Promotora';
      } else if (n >= 7) {
        this.escala = 'Neutra';
      } else {
        this.escala = 'Detratora';
      }
    },
    async submitFeedback() {
      this.loadingBtn = true;
      try {
        
        const userState = this.$store.state;
        const codIbge = userState.cod_ibge;
        const cidade = userState.cidade;
        const userId = userState.id;
        const userFuncao = userState.id_funcao;

        if (!userFuncao) {
          console.error('Função do usuário não encontrada no store.');
          this.loadingBtn = false;
          return;
        }

        const currentDate = new Date().toISOString().split('T')[0];

        const formData = {
          ibge: codIbge,
          cnes: null,
          ubs: null,
          municipio: cidade,
          dados: {
            nps: this.rating,
            escala: this.escala,
            funcao: userFuncao,
            termos: true,
            sugestao_critica_efb: this.feedback,
          },
        };

        const response = await apiPublic.post('/avaliacao-treinamento/avaliacao', formData);
        this.$toast.success(response.data.message, 'Sucesso:', {
          position: 'topRight',
        });

        const newJson = {
          id: userId,
          nps: currentDate,
        };
      
        this.enviadoComSucesso = true;
        this.resetFormulario();
      } catch (error) {
        console.error('Erro ao enviar os dados:', error);
        this.$toast.error('Erro ao enviar a avaliação.', 'Erro:', {
          position: 'topRight',
        });
      } finally {
        this.loadingBtn = false;
      }
      
      this.$emit('close');
    },
    async closeModal() {
      try {
        const userId = this.$store.state.id;
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0];
        
        const newJson = {
          id: userId,
          nps: formattedDate,
        };

        const npsResponse = await this.$api.post('/app/usuario/nps', newJson);
        sessionStorage.setItem('aptoAvaliacaoNps', 'false');
        
      } catch (error) {
        console.error('Erro ao enviar NPS ao fechar o modal:', error);
      }

      this.$emit('close');
    },
    resetFormulario() {
      this.feedback = '';
      this.rating = null;
      this.escala = '';
    }
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        this.closeModal();
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  width: min-content;
  max-width: 90%;
  text-align: center;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 50px;
  padding: 1rem 1rem 0px 0px;
}

.logo {
  width: 50px;
  margin-right: 10px;
}

.header-text {
  flex-grow: 1;
  text-align: left;
}

.modal-title {
  font-size: 18px;
  margin: 0;
}

.modal-subtitle {
  font-size: 14px;
  color: #777;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.nps-icons {
  display: flex;
  justify-content: space-between;
  margin: 30px 0;
  height: 70px;
}

.nps-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  margin: 10px 5px 0 0;
}

.nps-icons img {
  width: 40px;
  height: 40px;
  transition: transform 0.2s ease;
}

.nps-icons img.selected {
  transform: scale(1.2);
  border-radius: 50%;
  border: 2px solid #218838;
}

.nps-number {
  position: absolute;
  top: -18px;
  right: 2px;
  width: 20px;
  height: 20px;
  background-color: #a7a7a7;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(50%);
}

.nps-number.selected {
  background-color: #218838;
}

.textarea-container {
  width: 100%;
}

.textarea-wrapper {
  position: relative;
  width: 100%;
}

textarea {
  width: 100%;
  height: 100px;
  margin-top: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
  padding: 10px 50px 10px 10px;
  box-sizing: border-box;
  resize: none;
  font-size: 14px;
}

.microphone-container {
  position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    background: none;
}

.microphone-active {
  animation: pulse 1s infinite;
}

.submit-button {
  background-color: #28a745;
  color: white;
  padding: 10px 40px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
  box-shadow: inset 0 -2px 0 rgba(0, 0, 0, .25);
}

.submit-button:disabled {
  background-color: #ccc;
}

.submit-button:hover:enabled {
  background-color: #218838;
}

#footer-submit {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

@media (max-width: 500px) {
  .modal-content {
    padding: 20px;
    border-radius: 8px;
    max-width: 90%;
    text-align: center;
    width: 100%;
  }
  .modal-header {
    padding-bottom: 15px;
  }
  .nps-item {
    flex: 1 1 20%;
  }
  .img.selected {
    transform: scale(1.1);
  }
  .nps-icons {
    display: ruby !important;
    justify-content: center;
    margin: 20px 0;
    flex-wrap: wrap;
    gap: 10px;
  }
  .nps-number {
    position: absolute;
    top: -15px;
    right: 2px;
    width: 20px;
    height: 20px;
    background-color: #a7a7a7;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateY(50%);
    font-size: 12px;
  }
}
</style>
